module.exports = __webpack_public_path__ + "img/public/SiteIcons/speedmeterIconNew.svg?5d3782c6";